import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useSelectedRecommendedProjectSelector } from "../../store/projects/selectors";
import { ProjectInformation } from "./ProjectInformation/ProjectInformation";
import { ProjectDescription } from "../ProjectPage/components/ProjectDescription";
import { RegistryInformation } from "../ProjectPage/components/RegistryInfromation";
import { Breadcrumb } from "../../components/BreadCrumb";
import PeopleTab from "./PeopleTab/PeopleTab";
import ProjectTabs from "../ProjectPage/components/ProjectTabs";
import { RecommendedProjects } from "../ProjectPage/components/RecommendedProjects";

import { GoogleMapRecommendation } from "./Map/GoogleMapRecommendation";
import RecommendationPlanetTab from "./PlanetTab/RecommendationPlanetTab";
import TechnicalTab from "./TechnicalTab/TechnicalTab";
import RisksTab from "./RisksTab/RisksTab";
import { useRecommendationData } from "./hooks/data";
import TitleSection from "./TitleSection";

type RecommendationData = {
  sumOfConservation: number;
  sumOfReforestationHigh: number;
  sumOfReforestationLow: number;
  sumOfReforestationMedium: number;
  sumOfAboveGroundBiomassTonnes: number;
  sumOfSoilOrganicCarbonTonnes: number;
};

const RecommendationPage = () => {
  const { id } = useParams();
  const projectData = useSelectedRecommendedProjectSelector();

  const { geoJsonObjects, recommendationProjectData } = useRecommendationData(
    id as string,
    projectData,
  );

  const pdescription = !!projectData && (
    <>
      <span className="text-lg">{`${projectData.adm2} has total area of conservation in ${projectData.country}`}</span>
      <br />
      {/*<span className="text-md">{`Total tree cover: ${projectData?.total_tree_cover}`}</span> |{" "}*/}
      {/*<Badge*/}
      {/*  content={<span className="text-md">{`Total loss: ${projectData?.total_loss}%`}</span>}*/}
      {/*></Badge>*/}
      <br />
      <hr className="my-1"></hr>
      <span>{`Conservation: ${recommendationProjectData?.sumOfConservation}`}</span>
      <br />
      <span>{`Reforestation High: ${recommendationProjectData?.sumOfReforestationHigh}`}</span>
      <br />
      <span>{`Reforestation Medium: ${recommendationProjectData?.sumOfReforestationMedium}`}</span>
      <br />
      <span>{`Reforestation Low: ${recommendationProjectData?.sumOfReforestationLow}`}</span>
      <br />
      <span>{`Above Ground Biomass in Tonnes: ${recommendationProjectData?.sumOfAboveGroundBiomassTonnes}`}</span>
      <br />
      <span>{`Soil Organic Carbon in Tonnes: ${recommendationProjectData?.sumOfSoilOrganicCarbonTonnes}`}</span>
      <br />
      {/* <span>{`Area: ${projectData?.area}`}</span>
      <br />
      <span>{`Perimeter: ${projectData?.perimeter}`}</span>
      <br />
      <span>{`GAZ No: ${projectData?.gaz_no}`}</span>
      <br />
      <span>{`GAZ date: ${projectData?.date_gaz}`}</span>
      <br />
      <span>{`PA types: ${projectData?.pa_types}`}</span>
      <br />
      <span>{`Data source: ${projectData?.data_source}`}</span>
      <br />
      <span>{`Remarkes: ${projectData?.remarkes}`}</span>
      <br /> */}
      <br />
    </>
  );
  const projectDetailPageTabs = [
    {
      title: "Overview",
      value: "Overview",
      content: (
        <section className="grid grid-cols-2 gap-6">
          <div className="flex flex-col gap-6">
            <ProjectDescription description={pdescription ?? ""} />
            <RegistryInformation
              information={
                "Verra sets the world’s leading standards for climate action and sustainable development. We build standards for activities as diverse as reducing deforestation."
              }
            />
          </div>
          <div>
            <GoogleMapRecommendation
              geoJsonObjects={geoJsonObjects}
              mapContainerStyle={{
                width: "100%",
                height: "400px",
                borderRadius: "5px",
              }}
            />
          </div>
        </section>
      ),
    },
    {
      title: "People",
      value: "People",
      content: <PeopleTab />,
    },
    {
      title: "Planet",
      value: "Planet",
      content: (
        <section className="grid grid-cols-1 gap-6">
          {/*<LULCMap />*/}
          <RecommendationPlanetTab />
        </section>
      ),
    },
    {
      title: "Technical",
      value: "Technical",
      content: <TechnicalTab recommendationProjectData={recommendationProjectData} />,
    },
    {
      title: "Risks & Compliance", // Add this new tab
      value: "Risks",
      content: <RisksTab />,
    },
    /*    {
          title: "Finance",
          value: "Finance",
          content: "",
        },*/
  ];

  return projectData ? (
    <div className="flex w-full flex-col gap-4 px-6">
      <Breadcrumb />
      <TitleSection projectData={projectData} />
      <section className="relative flex flex-row items-center gap-10">
        <ProjectInformation
          projectData={{
            ...projectData,
            estimated_annual_credit: Math.round(
              (recommendationProjectData.sumOfReforestationHigh +
                recommendationProjectData.sumOfReforestationMedium +
                recommendationProjectData.sumOfReforestationLow) *
                10,
            ),
          }}
        />
      </section>

      <ProjectTabs projectDetailPageTabs={projectDetailPageTabs} />
      <section className="relative flex flex-row items-center gap-10">
        <RecommendedProjects />
      </section>
    </div>
  ) : null;
};

export default RecommendationPage;
